<a [href]="viewUnitOnACMUrl" target="_blank" rel="noopener">{{ 'KEY_FACTS.viewUnitOnACM' | translate }}</a>
